import { MainContentArea } from "melco-ui";

export const Error404 = () => (
  <>
    <MainContentArea>
    
     <div>404 Not Found</div> 
    </MainContentArea>
  </>
);
